import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DataGridPro, GridToolbar, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function ProjectsUnassignedLoadsLookup(props){
    //console.debug("RTS Break ProjectsUnassignedLoadsLookup");

    const {sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const formatObj = new Intl.DateTimeFormat("en-US");    

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);

    const [repoLoads, setRepoLoads] = useState([]);

    useEffect(() => {
        setRepoLoads(props.loadList);
        setIsLoading(false);
    }, []);  

    
    function handleClick(e, cellValues){
        let selectedRowData = repoLoads.filter((row) => selectionModel.includes(row.idGuid.toString()));
        props.addLoadLocksFx(selectedRowData);
    }


    const columns = [
        {
            ...GRID_CHECKBOX_SELECTION_COL_DEF,
            hideable: false,
            headerName: 'Selection'
        },         
        {
            field: 'curAliasName', 
            headerName: "Product", 
            description:"Southwire Product Id", 
            flex:smallForm?4:5,
        },
        {
            field: 'shipDate', 
            headerName: "Ship Date", 
            description:"Reel Ship Date", 
            flex:2,           
            valueFormatter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    formatObj.format(new Date(value))
                );
            },
            align:'center'
        },
        {
            field: 'curReelSerialNumber', 
            headerName: "Reel", 
            description:"Reel Serial Number", 
            flex:smallForm?4:2,
            hideable:false,
        }, 
        {
            field: 'customerPo', 
            headerName: "Purchase Order", 
            description:"Purchase Order", 
            flex:smallForm?4:2,
            hideable:true,
        }, 
        {
            field: 'curTrackerESN', 
            headerName: "Tracker", 
            description:"Tracker ESN", 
            flex:smallForm?4:2,
            hideable:true,
        }, 
        {
            field: 'shipDateDays', 
            headerName: "Age (Days)", 
            description:"Reel Age", 
            flex:2,
            valueFormatter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right'
        },             
        {
            field: 'remainingLength', 
            headerName: "Remaining (ft)", 
            description:"Remaining Length", 
            flex:2,
            valueGetter: (value, row) => {
                return row.amt - row.curPullSum;
            },            
            valueFormatter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right'
        }, 
        {
            field: 'deferralDaysLeft', 
            headerName: "Deferral (Days)", 
            description:"Defferal Days Left", 
            flex:2,
            valueFormatter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right'
        },                     
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {shipDate:false, age:false, remainingLength:false, deferralDaysLeft:false}
        }
        else{
            return {age:false, deferralDaysLeft:false}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    if(hasError){
        return(
            <Error />
        );
    };
    
    
    if(isLoading){
        return(
            <Loading />
        );
    };    


    return (
        <Box>
            <Box sx={{height:"400px"}}>
                <DataGridPro 
                    checkboxSelection={true} 
                    pagination
                    slots={{toolbar: GridToolbar}}
                    slotProps={{
                        toolbar:{
                            showQuickFilter:true,
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: true },                        
                        }
                    }}                    
                    rows={repoLoads} 
                    columns={columns} 
                    getRowId={row => row.idGuid}
                    onRowSelectionModelChange={(newSelectionModel) => {
                        setSelectionModel(newSelectionModel);
                    }}
                    selectionModel={selectionModel}
                    initialState={{
                        columns:{
                            columnVisibilityModel: getVisibilityModel()
                        },
                        pagination: { paginationModel: { pageSize: 50 } },
                        density: getDensity() 
    
                    }}                          
                />
            </Box>
            <Box sx={{mt:2, textAlign:'right'}}>
                <Button variant="contained" onClick={handleClick} sx={{mr:2}}>Lock Reels</Button>
                <Button variant="contained" onClick={e => {props.setShowLoadLocksModalFx(false);}}>Cancel</Button>
            </Box>
        </Box>
    );
}
